import React from 'react';
import ReactDOM from 'react-dom/client';
import { injectCssVariables } from '@kome/shared';
import App from '@/App';
import '@/styles/global.css';

// 디자인 토큰을 :root CSS 변수로 주입 (색상/간격/반경 등)
injectCssVariables();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
